//Alert types
import { SET_ALERT, REMOVE_ALERT } from "../actions/types";

const initialState = [];

export default function (state = initialState, action) {
  //Destructure action
  const { type, payload } = action;

  switch (type) {
    case SET_ALERT:
      //Add alert payload to state
      return [...state, payload];
    case REMOVE_ALERT:
      //Remove alert by id (return all alerts except one matching payload)
      return state.filter((alert) => alert.id !== payload);
    default:
      return state;
  }
}
